export default "firebase.messaging().onMessage(payload => {\n    setNotificationMessage(payload.notification);\n});"